module.exports = __webpack_public_path__ + "static/city3-fbdf8e8093d8258c95b15d59a2edc47f.jpg";